(function () {
  var root = document.getElementById('HarrogateCartDrawer');
  if (!root) return;

  var panel = root.querySelector('.ho-cart-drawer__panel');
  var body = root.querySelector('[data-cart-drawer-body]');
  var itemsMount = root.querySelector('[data-cart-drawer-items]');
  var notice = root.querySelector('[data-cart-drawer-notice]');
  var progress = root.querySelector('[data-cart-drawer-progress]');
  var rewardMessage = root.querySelector('[data-cart-drawer-reward-message]');
  var shippingCard = root.querySelector('[data-cart-drawer-shipping-card]');
  var giftCard = root.querySelector('[data-cart-drawer-gift-card]');
  var subtotal = root.querySelector('[data-cart-drawer-subtotal]');
  var subtotalLabel = root.querySelector('[data-cart-drawer-subtotal-label]');
  var checkout = root.querySelector('[data-cart-drawer-checkout]');
  var giftWrapTrigger = root.querySelector('[data-cart-drawer-gift-wrap-trigger]');
  var giftWrapCheckbox = root.querySelector('[data-cart-drawer-gift-wrap-checkbox]');
  var giftModal = root.querySelector('[data-cart-drawer-gift-modal]');
  var giftForm = root.querySelector('[data-cart-drawer-gift-form]');
  var giftModalNotice = root.querySelector('[data-cart-drawer-gift-modal-notice]');
  var recommendations = root.querySelector('[data-cart-drawer-recommendations]');
  var recommendationTrack = root.querySelector('[data-cart-drawer-recommendation-track]');
  var recommendationPrev = root.querySelector('[data-cart-drawer-recommendation-prev]');
  var recommendationNext = root.querySelector('[data-cart-drawer-recommendation-next]');
  var vitaminDOffer = root.querySelector('[data-cart-drawer-vitamin-d-offer]');
  var vitaminDQualifyingPrompt = root.querySelector('[data-cart-drawer-vitamin-d-qualifying-prompt]');
  var vitaminDOfferButton = root.querySelector('[data-cart-drawer-vitamin-d-add]');
  var vitaminDOfferConfig = readVitaminDOfferConfig(root.querySelector('[data-cart-drawer-vitamin-d-config]'));
  var vitaminDOfferAdding = false;

  var cartUrl = root.dataset.cartUrl || '/cart';
  var addUrl = root.dataset.cartAddUrl || '/cart/add';
  var changeUrl = root.dataset.cartChangeUrl || '/cart/change';
  var updateUrl = root.dataset.cartUpdateUrl || '/cart/update';
  var checkoutUrl = root.dataset.checkoutUrl || cartUrl || '/cart';
  var moneyFormat = root.dataset.moneyFormat || (window.theme && window.theme.money_format) || '\u00a3{{amount}}';
  var shippingThreshold = parseInt(root.dataset.shippingThreshold || '5000', 10);
  var freeGiftThreshold = parseInt(root.dataset.freeGiftThreshold || '6000', 10);
  var giftWrapVariantId = parseInt(root.dataset.giftWrapVariantId || '0', 10);
  var freeGiftProductId = parseInt(root.dataset.freeGiftProductId || '0', 10);
  var freeGiftVariantId = parseInt(root.dataset.freeGiftVariantId || '0', 10);
  var freeGiftBarId = root.dataset.freeGiftBarId || '';
  var freeGiftTierId = root.dataset.freeGiftTierId || '';
  var smartSubscriptionSampleProductId = parseInt(root.dataset.smartSubscriptionSampleProductId || '0', 10);
  var smartSubscriptionSampleVariantId = parseInt(root.dataset.smartSubscriptionSampleVariantId || '0', 10);
  var smartSubscriptionSampleSku = root.dataset.smartSubscriptionSampleSku || 'MagnesiumSample';
  var magnesiumSmartGiftVariantId = parseInt(root.dataset.magnesiumSmartGiftVariantId || '0', 10);
  var magnesiumSmartGiftSku = String(root.dataset.magnesiumSmartGiftSku || 'freepillowspray').trim().toLowerCase();
  var magnesiumSmartGiftProductHandle = root.dataset.magnesiumSmartGiftProductHandle || '';
  var state = {
    cart: null,
    isOpen: false,
    isGiftModalOpen: false,
    isCartChanging: false,
    cartMutationCount: 0,
    isSyncingFreeGift: false,
    isSyncingSmartSubscriptionSample: false,
    normalizationQueue: null,
    magnesiumSmartGiftUnsafe: false,
    magnesiumSmartGiftNotice: '',
    lastFocus: null,
    productCache: {},
    recommendationSeed: null
  };

// Only the Vitamin D homepage banner adds this one-use redirect marker.
function consumeVitaminDBannerDrawerRequest() {
  var destination;
  try {
    destination = new URL(window.location.href);
  } catch (error) {
    return false;
  }
  if (!/\/pages\/october-vitamin-d-offer\/?$/.test(destination.pathname) ||
      destination.searchParams.get('ho_d3_banner_cart') !== '1') return false;
  destination.searchParams.delete('ho_d3_banner_cart');
  try {
    // Remove the marker so reloads and ordinary subsequent visits stay closed.
    window.history.replaceState(window.history.state, '', destination.pathname + destination.search + destination.hash);
  } catch (error) {
    // A history restriction must not prevent the requested drawer opening.
  }
  return true;
}


  function init() {
    bindEvents();
    exposeApi();
    fetchCart(consumeVitaminDBannerDrawerRequest() ? { open: true } : { renderOnly: true });
    if (vitaminDOfferConfig) {
      window.setInterval(function () { renderVitaminDOffer(state.cart); }, 60000);
    }
  }

  function bindEvents() {
    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('submit', onDocumentSubmit, true);
    document.addEventListener('keydown', onKeydown);

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-drawer-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.target.closest('[data-cart-drawer-gift-modal-close]')) {
        event.preventDefault();
        closeGiftWrapModal();
        return;
      }

      var giftWrapButton = event.target.closest('[data-cart-drawer-gift-wrap-trigger]');
      if (giftWrapButton) {
        event.preventDefault();
        toggleGiftWrap();
        return;
      }

      var qtyButton = event.target.closest('[data-cart-drawer-quantity-button]');
      if (qtyButton) {
        event.preventDefault();
        changeQuantity(qtyButton.dataset.key, parseInt(qtyButton.dataset.quantity, 10));
        return;
      }

      var removeButton = event.target.closest('[data-cart-drawer-remove]');
      if (removeButton) {
        event.preventDefault();
        changeQuantity(removeButton.dataset.key, 0);
        return;
      }

      var tierButton = event.target.closest('[data-cart-drawer-tier]');
      if (tierButton) {
        event.preventDefault();
        changeQuantity(tierButton.dataset.key, parseInt(tierButton.dataset.quantity, 10));
        return;
      }

      var subscription = event.target.closest('[data-cart-drawer-subscription]');
      if (subscription && !event.target.closest('a')) {
        event.preventDefault();
        upgradeToSubscription(subscription);
        return;
      }

      var vitaminDOfferAdd = event.target.closest('[data-cart-drawer-vitamin-d-add]');
      if (vitaminDOfferAdd) {
        event.preventDefault();
        addVitaminDOffer(vitaminDOfferAdd);
        return;
      }

      var addRecommendation = event.target.closest('[data-cart-drawer-recommendation-add]');
      if (addRecommendation) {
        event.preventDefault();
        addVariant(addRecommendation.dataset.variantId, 1, addRecommendation);
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-cart-drawer-quantity-input]')) {
        var quantity = Math.max(0, parseInt(event.target.value || '0', 10));
        changeQuantity(event.target.dataset.key, quantity);
      }
    });

    root.addEventListener('submit', function (event) {
      if (event.target.matches('[data-cart-drawer-gift-form]')) {
        event.preventDefault();
        addGiftWrapFromForm(event.target);
      }
    });

    if (recommendationPrev) {
      recommendationPrev.addEventListener('click', function () {
        scrollRecommendations(-1);
      });
    }

    if (recommendationNext) {
      recommendationNext.addEventListener('click', function () {
        scrollRecommendations(1);
      });
    }
  }

  function exposeApi() {
    var api = {
      open: openDrawer,
      close: closeDrawer,
      fetchCart: fetchCart,
      prepareCheckout: prepareCheckout,
      addItemToCart: function (formId) {
        var form = document.getElementById(formId);
        if (form) addFromForm(form);
      },
      fetchAndOpenCart: function () {
        fetchCart({ open: true });
      },
      removeItem: function (lineOrKey) {
        changeQuantity(lineOrKey, 0);
      },
      changeItemQuantity: changeQuantity
    };

    window.HarrogateCartDrawer = api;
    window.openHarrogateCartDrawer = function (event) {
      if (event && typeof event.preventDefault === 'function') event.preventDefault();
      fetchCart({ open: true });
      return false;
    };
    window.openRebuySmartCart = window.openHarrogateCartDrawer;
  }

  function onDocumentClick(event) {
    if (event.target.closest('[data-cart-drawer-checkout]') && magnesiumSmartGiftVariantId > 0) {
      event.preventDefault();
      prepareCheckout().then(function () {
        window.location.assign(checkoutUrl);
      }).catch(function (error) {
        showNotice(error.message || 'Your free pillow spray could not be checked. Please try again.');
      });
      return;
    }

    var drawerTrigger = event.target.closest('[data-rebuy-smart-cart-trigger], .js-go-cart-trigger');
    if (drawerTrigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      fetchCart({ open: true });
      return;
    }

    var addButton = event.target.closest('.js-go-cart-add-to-cart');
    if (!addButton || addButton.closest('#HarrogateCartDrawer')) return;

    var form = addButton.closest('form');
    if (!form) return;

    event.preventDefault();
    addFromForm(form, addButton);
  }

  function onDocumentSubmit(event) {
    var form = event.target;
    if (!form || form.closest('#HarrogateCartDrawer')) return;
    if (!form.querySelector('.js-go-cart-add-to-cart')) return;

    event.preventDefault();
    addFromForm(form, form.querySelector('.js-go-cart-add-to-cart'));
  }

  function onKeydown(event) {
    if (!state.isOpen) return;

    if (state.isGiftModalOpen && event.key === 'Escape') {
      closeGiftWrapModal();
      return;
    }

    if (state.isGiftModalOpen) {
      trapFocus(event, giftForm);
      return;
    }

    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }

    trapFocus(event, panel);
  }

  function trapFocus(event, container) {
    if (event.key !== 'Tab' || !container) return;

    var focusable = container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function fetchCart(options) {
    options = options || {};
    return fetch(cartUrl + '.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    })
      .then(parseResponse)
      .then(normalizeCart)
      .then(function (cart) {
        if (options.open) openDrawer();
        return cart;
      })
      .catch(function (error) {
        showNotice(error.message || 'Something went wrong. Please try again.');
        if (options.open) openDrawer();
      });
  }

  function normalizeCart(cart) {
    if (magnesiumSmartGiftVariantId > 0) {
      // Cart reads and mutations can overlap. Re-read inside one reconciliation queue
      // instead of letting a second pass render a stale cart while a gift is added.
      var task = (state.normalizationQueue || Promise.resolve()).catch(function () {}).then(fetchCartJson).then(function (freshCart) {
        state.magnesiumSmartGiftNotice = '';
        return syncFreeGift(freshCart).then(syncSmartSubscriptionSample).then(syncMagnesiumSmartGift);
      }).then(function (updatedCart) {
        state.cart = updatedCart;
        render(updatedCart);
        if (state.magnesiumSmartGiftNotice) showNotice(state.magnesiumSmartGiftNotice);
        return updatedCart;
      });
      state.normalizationQueue = task;
      return task;
    }

    state.cart = cart;
    return syncFreeGift(cart).then(syncSmartSubscriptionSample).then(function (updatedCart) {
      state.cart = updatedCart;
      render(updatedCart);
      return updatedCart;
    });
  }

  function prepareCheckout() {
    if (state.cartMutationCount > 0 || state.isCartChanging) {
      return Promise.reject(new Error('Your basket is still updating. Please wait a moment and try checkout again.'));
    }
    return fetchCartJson().then(normalizeCart).then(function (cart) {
      if (state.cartMutationCount > 0 || state.isCartChanging) {
        throw new Error('Your basket is still updating. Please wait a moment and try checkout again.');
      }
      if (magnesiumSmartGiftVariantId > 0 && (state.magnesiumSmartGiftUnsafe || !isMagnesiumSmartGiftCartValid(cart))) {
        throw new Error(state.magnesiumSmartGiftNotice || 'Your free pillow spray could not be confirmed. Please refresh your basket before checkout.');
      }
      return cart;
    });
  }

  function addFromForm(form, button) {
    var formData = new FormData(form);
    state.cartMutationCount += 1;
    setBusy(button, true, 'Adding...');

    return fetch(addUrl + '.js', {
      credentials: 'same-origin',
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(parseResponse)
      .then(function (response) {
        dispatchCartAdd(response);
        return fetchCart({ open: true });
      })
      .catch(function (error) {
        showNotice(error.message || 'This item could not be added to your cart.');
        openDrawer();
      })
      .finally(function () {
        state.cartMutationCount -= 1;
        setBusy(button, false);
      });
  }

  function addVariant(variantId, quantity, button) {
    if (!variantId) return;
    state.cartMutationCount += 1;
    setBusy(button, true, 'Adding...');

    return fetch(addUrl + '.js', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    })
      .then(parseResponse)
      .then(function (response) {
        dispatchCartAdd(response);
        return fetchCart({ open: true });
      })
      .catch(function (error) {
        showNotice(error.message || 'This item could not be added to your cart.');
      })
      .finally(function () {
        state.cartMutationCount -= 1;
        setBusy(button, false);
      });
  }

  function changeQuantity(keyOrLine, quantity) {
    if (!keyOrLine && keyOrLine !== 0) return;
    if (state.isCartChanging) return;
    var item = state.cart && state.cart.items && state.cart.items.find(function (line) {
      return line.key === keyOrLine;
    });
    if (isMagnesiumSmartLine(item) && quantity > 0) {
      quantity = Math.max(4, Math.ceil(quantity / 4) * 4);
    }
    state.isCartChanging = true;
    state.cartMutationCount += 1;
    setRootLoading(true);

    return fetch(changeUrl + '.js', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: keyOrLine, quantity: Math.max(0, quantity) })
    })
      .then(parseResponse)
      .then(normalizeCart)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
        return cart;
      })
      .catch(function (error) {
        showNotice(error.message || 'Your cart could not be updated.');
      })
      .finally(function () {
        state.cartMutationCount -= 1;
        state.isCartChanging = false;
        setRootLoading(false);
      });
  }

  function toggleGiftWrap() {
    var cart = state.cart;
    if (!cart || cart.item_count === 0 || state.isCartChanging) return;

    var giftWrapItem = findGiftWrapItem(cart);
    if (giftWrapItem) {
      removeGiftWrap(giftWrapItem);
      return;
    }

    openGiftWrapModal();
  }

  function openGiftWrapModal() {
    if (!giftModal || !giftForm) return;

    clearGiftWrapNotice();
    state.isGiftModalOpen = true;
    giftModal.hidden = false;
    giftModal.setAttribute('aria-hidden', 'false');

    window.setTimeout(function () {
      var firstInput = giftForm.querySelector('input, textarea, button');
      if (firstInput) firstInput.focus();
    }, 20);
  }

  function closeGiftWrapModal() {
    if (!giftModal) return;

    state.isGiftModalOpen = false;
    giftModal.hidden = true;
    giftModal.setAttribute('aria-hidden', 'true');
    clearGiftWrapNotice();

    if (giftWrapTrigger && typeof giftWrapTrigger.focus === 'function') {
      giftWrapTrigger.focus();
    }
  }

  function addGiftWrapFromForm(form) {
    if (!giftWrapVariantId) {
      showGiftWrapNotice('Gift wrap is not available right now.');
      return;
    }

    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

    var formData = new FormData(form);
    var sender = String(formData.get('sender') || '').trim();
    var receiver = String(formData.get('receiver') || '').trim();
    var message = String(formData.get('message') || '').trim();

    if (!sender || !receiver || !message) {
      showGiftWrapNotice('Please complete all gift wrap fields.');
      return;
    }

    var button = form.querySelector('button[type="submit"]');
    state.cartMutationCount += 1;
    setBusy(button, true, 'Adding...');
    setRootLoading(true);

    return fetch(addUrl + '.js', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: giftWrapVariantId,
        quantity: 1,
        properties: {
          'Sender': sender,
          'Receiver': receiver,
          'Gift message': message
        }
      })
    })
      .then(parseResponse)
      .then(function (response) {
        form.reset();
        closeGiftWrapModal();
        dispatchCartAdd(response);
        return fetchCart({ open: true });
      })
      .catch(function (error) {
        showGiftWrapNotice(error.message || 'Gift wrap could not be added.');
      })
      .finally(function () {
        state.cartMutationCount -= 1;
        setBusy(button, false);
        setRootLoading(false);
      });
  }

  function removeGiftWrap(item) {
    if (!item || !item.key) return;
    state.cartMutationCount += 1;
    setRootLoading(true);

    return postCartChange({ id: item.key, quantity: 0 })
      .then(normalizeCart)
      .then(function () {
        document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
      })
      .catch(function (error) {
        showNotice(error.message || 'Gift wrap could not be removed.');
      })
      .finally(function () {
        state.cartMutationCount -= 1;
        setRootLoading(false);
      });
  }

  function syncFreeGift(cart) {
    if (!freeGiftVariantId || state.isSyncingFreeGift) return Promise.resolve(cart);

    var giftItem = findFreeGiftItem(cart);
    var rewardTotal = rewardSubtotal(cart);
    var shouldHaveGift = !hasQualifyingSmartSubscription(cart)
      && rewardTotal >= freeGiftThreshold
      && hasQualifyingItems(cart);

    if (shouldHaveGift && (!giftItem || !isCurrentFreeGiftLine(giftItem))) {
      if (giftItem) {
        return removeFreeGift(giftItem, cart).then(function (updatedCart) {
          return findFreeGiftItem(updatedCart) ? updatedCart : addFreeGift(updatedCart);
        });
      }

      return addFreeGift(cart);
    }

    if (!shouldHaveGift && giftItem) {
      return removeFreeGift(giftItem, cart);
    }

    if (giftItem && giftItem.quantity !== 1) {
      return setFreeGiftQuantity(giftItem, cart);
    }

    return Promise.resolve(cart);
  }

  function addFreeGift(fallbackCart) {
    state.isSyncingFreeGift = true;

    return ensureFreeGiftBar(fallbackCart)
      .then(function () {
        return fetch(addUrl + '.js', {
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: freeGiftVariantId,
              quantity: 1,
              properties: freeGiftProperties()
            }]
          })
        });
      })
      .then(parseResponse)
      .then(fetchCartJson)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
        return cart;
      })
      .catch(function () {
        showNotice('Your free gift could not be added automatically.');
        return fallbackCart;
      })
      .finally(function () {
        state.isSyncingFreeGift = false;
      });
  }

  function removeFreeGift(item, fallbackCart) {
    state.isSyncingFreeGift = true;

    return postCartChange({ id: item.key, quantity: 0 })
      .then(fetchCartJson)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
        return cart;
      })
      .catch(function () {
        return fallbackCart;
      })
      .finally(function () {
        state.isSyncingFreeGift = false;
      });
  }

  function setFreeGiftQuantity(item, fallbackCart) {
    state.isSyncingFreeGift = true;

    return postCartChange({ id: item.key, quantity: 1 })
      .then(fetchCartJson)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
        return cart;
      })
      .catch(function () {
        return fallbackCart;
      })
      .finally(function () {
        state.isSyncingFreeGift = false;
      });
  }

  function syncSmartSubscriptionSample(cart) {
    if (state.isSyncingSmartSubscriptionSample) return Promise.resolve(cart);

    if (!smartSubscriptionSampleVariantId) {
      if (hasQualifyingSampleSubscription(cart) && window.console && typeof window.console.warn === 'function') {
        window.console.warn('Smart subscription sample is not configured. Set the MagnesiumSample variant ID in Cart theme settings.');
      }

      return Promise.resolve(cart);
    }

    var sampleItem = findSmartSubscriptionSampleItem(cart);
    var shouldHaveSample = hasQualifyingSampleSubscription(cart);

    if (shouldHaveSample && (!sampleItem || !isCurrentSmartSubscriptionSampleLine(sampleItem))) {
      if (sampleItem) {
        return removeSmartSubscriptionSample(sampleItem, cart).then(function (updatedCart) {
          return findSmartSubscriptionSampleItem(updatedCart) ? updatedCart : addSmartSubscriptionSample(updatedCart);
        });
      }

      return addSmartSubscriptionSample(cart);
    }

    if (!shouldHaveSample && sampleItem) {
      return removeSmartSubscriptionSample(sampleItem, cart);
    }

    if (sampleItem && sampleItem.quantity !== 1) {
      return setSmartSubscriptionSampleQuantity(sampleItem, cart);
    }

    return Promise.resolve(cart);
  }

  function addSmartSubscriptionSample(fallbackCart) {
    state.isSyncingSmartSubscriptionSample = true;

    return fetch(addUrl + '.js', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: smartSubscriptionSampleVariantId,
          quantity: 1,
          properties: smartSubscriptionSampleProperties()
        }]
      })
    })
      .then(parseResponse)
      .then(fetchCartJson)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
        return cart;
      })
      .catch(function () {
        showNotice('Your free magnesium sample could not be added automatically.');
        return fallbackCart;
      })
      .finally(function () {
        state.isSyncingSmartSubscriptionSample = false;
      });
  }

  function removeSmartSubscriptionSample(item, fallbackCart) {
    state.isSyncingSmartSubscriptionSample = true;

    return postCartChange({ id: item.key, quantity: 0 })
      .then(fetchCartJson)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
        return cart;
      })
      .catch(function () {
        return fallbackCart;
      })
      .finally(function () {
        state.isSyncingSmartSubscriptionSample = false;
      });
  }

  function setSmartSubscriptionSampleQuantity(item, fallbackCart) {
    state.isSyncingSmartSubscriptionSample = true;

    return postCartChange({ id: item.key, quantity: 1 })
      .then(fetchCartJson)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
        return cart;
      })
      .catch(function () {
        return fallbackCart;
      })
      .finally(function () {
        state.isSyncingSmartSubscriptionSample = false;
      });
  }

  function fetchCartJson() {
    return fetch(cartUrl + '.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    }).then(parseResponse);
  }

  function verifyMagnesiumSmartGiftVariant() {
    if (!magnesiumSmartGiftProductHandle) return Promise.reject(new Error('The free pillow spray is not configured.'));
    var localeRoot = cartUrl.replace(/\/cart\/?$/, '');
    return fetch(localeRoot + '/products/' + encodeURIComponent(magnesiumSmartGiftProductHandle) + '.js', {
      credentials: 'same-origin',
      method: 'GET',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).then(parseResponse).then(function (product) {
      var variant = (product.variants || []).find(function (candidate) {
        return Number(candidate.id) === magnesiumSmartGiftVariantId;
      });
      if (!variant || String(variant.sku || '').trim().toLowerCase() !== magnesiumSmartGiftSku
        || variant.price !== 0 || variant.available !== true || product.requires_selling_plan === true) {
        throw new Error('The free pillow spray is currently unavailable. Please contact us before checking out.');
      }
      return variant;
    });
  }

  function magnesiumSmartGiftProperties() {
    return {
      _source: 'Harrogate Organics',
      _attribution: 'Magnesium Smart Pillow Gift',
      _magnesium_smart_gift: 'true'
    };
  }

  function removeMagnesiumSmartGiftLines(lines) {
    var updates = {};
    lines.forEach(function (item) { updates[item.key] = 0; });
    return postCartUpdate({ updates: updates }).then(fetchCartJson);
  }

  async function syncMagnesiumSmartGift(cart) {
    if (!(magnesiumSmartGiftVariantId > 0)) return cart;
    var updatedCart = cart;
    var verifiedVariant = false;
    try {
      // Bounded fresh-cart passes handle duplicates and an eligibility change while
      // the variant lookup or cart mutation is in flight.
      for (var attempt = 0; attempt < 6; attempt += 1) {
        var quantity = magnesiumSmartGiftQuantity(updatedCart);
        var giftItems = (updatedCart.items || []).filter(isMagnesiumSmartGiftItem);
        if (verifiedVariant && giftItems.some(function (item) {
          var price = item.final_line_price != null ? item.final_line_price : item.line_price;
          return price == null || Number(price) !== 0;
        })) {
          throw new Error('The pillow spray price changed. We could not confirm your free gift. Please contact us before checkout.');
        }
        var keeper = quantity > 0 ? giftItems.find(isCurrentMagnesiumSmartGiftLine) : null;
        var removals = giftItems.filter(function (item) { return item !== keeper; });
        if (removals.length) {
          updatedCart = await removeMagnesiumSmartGiftLines(removals);
          continue;
        }
        if (!quantity || (keeper && keeper.quantity === quantity)) {
          state.magnesiumSmartGiftUnsafe = false;
          return updatedCart;
        }
        if ((!keeper || keeper.quantity < quantity) && !verifiedVariant) {
          await verifyMagnesiumSmartGiftVariant();
          verifiedVariant = true;
          updatedCart = await fetchCartJson();
          continue;
        }
        if (keeper) {
          await postCartChange({ id: keeper.key, quantity: quantity });
        } else {
          await fetch(addUrl + '.js', {
            credentials: 'same-origin',
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            // No selling_plan: the pillow is a one-time first-shipment item.
            body: JSON.stringify({ items: [{ id: magnesiumSmartGiftVariantId, quantity: quantity, properties: magnesiumSmartGiftProperties() }] })
          }).then(parseResponse);
        }
        updatedCart = await fetchCartJson();
      }
      throw new Error('Your basket changed while we were adding your free pillow spray. Please try again.');
    } catch (error) {
      state.magnesiumSmartGiftNotice = error.message || 'Your free pillow spray could not be added. Please try again.';
      // An unsuccessful response can still follow a successful server-side write.
      // Read the real cart and remove an unsafe gift rather than returning an old snapshot.
      try {
        updatedCart = await fetchCartJson();
        var invalidGifts = (updatedCart.items || []).filter(function (item) {
          return isMagnesiumSmartGiftItem(item) && (!isCurrentMagnesiumSmartGiftLine(item) || !magnesiumSmartGiftQuantity(updatedCart));
        });
        if (invalidGifts.length) updatedCart = await removeMagnesiumSmartGiftLines(invalidGifts);
        state.magnesiumSmartGiftUnsafe = !isMagnesiumSmartGiftCartValid(updatedCart);
      } catch (recoveryError) {
        state.magnesiumSmartGiftUnsafe = true;
      }
      return updatedCart;
    }
  }

  function ensureFreeGiftBar(cart) {
    if (!freeGiftBarId) return Promise.resolve(cart);

    var attributes = cart && cart.attributes ? cart.attributes : {};
    if (attributes._barId === freeGiftBarId) return Promise.resolve(cart);

    return postCartUpdate({ attributes: { _barId: freeGiftBarId } });
  }

  function freeGiftProperties() {
    var properties = {
      _source: 'Rebuy',
      _attribution: 'Rebuy Tiered Progress Bar'
    };

    if (freeGiftTierId) properties._tier = freeGiftTierId;

    return properties;
  }

  function smartSubscriptionSampleProperties() {
    return {
      _source: 'Harrogate Organics',
      _attribution: 'Smart Subscription Sample',
      _smart_subscription_sample: 'true'
    };
  }

  function postCartChange(payload) {
    return fetch(changeUrl + '.js', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(parseResponse);
  }

  function postCartUpdate(payload) {
    return fetch(updateUrl + '.js', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(parseResponse);
  }

  function dispatchCartAdd(response) {
    var items = response && response.items ? response.items : (response ? [response] : []);
    var detail = {
      item: items[0] || null,
      items: items,
      response: response || null
    };

    document.dispatchEvent(new CustomEvent('harrogate:cart.add', { detail: detail }));
    document.dispatchEvent(new CustomEvent('rebuy:cart.add', { detail: detail }));
  }

  function upgradeToSubscription(label) {
    if (label.dataset.loading === 'true') return;

    var key = label.dataset.key;
    var quantity = parseInt(label.dataset.quantity || '1', 10);
    var handle = label.dataset.productHandle;

    if (!key || !handle) return;
    label.dataset.loading = 'true';
    state.cartMutationCount += 1;

    return getProduct(handle)
      .then(function (product) {
        var plan = firstSellingPlan(product);
        if (!plan) throw new Error('Subscription is not available for this product.');

        return fetch(changeUrl + '.js', {
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: key, quantity: quantity, selling_plan: plan.id })
        });
      })
      .then(parseResponse)
      .then(normalizeCart)
      .then(function () {
        document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
      })
      .catch(function (error) {
        showNotice(error.message || 'Subscription upgrade could not be applied.');
      })
      .finally(function () {
        state.cartMutationCount -= 1;
        label.dataset.loading = 'false';
      });
  }

  function render(cart) {
    clearNotice();
    updateCounters(cart);
    renderRewards(cart);
    renderFooter(cart);
    renderItems(cart);
    renderVitaminDOffer(cart);
    renderRecommendations(cart);
    hydrateSubscriptionRows(cart);
  }

  function renderRewards(cart) {
    var total = rewardSubtotal(cart);
    var subscriptionShipping = hasSubscriptionFreeShipping(cart);
    var shippingUnlocked = total >= shippingThreshold || subscriptionShipping;
    var target = Math.max(freeGiftThreshold, shippingThreshold);
    var percent = target > 0 ? Math.min(100, total / target * 100) : 100;

    if (progress) progress.style.width = percent + '%';
    toggleClass(shippingCard, 'is-unlocked', shippingUnlocked);
    toggleClass(giftCard, 'is-unlocked', total >= freeGiftThreshold);

    if (!rewardMessage) return;

    if (cart.item_count === 0) {
      rewardMessage.innerHTML = 'Your cart is ready when you are.';
    } else if (!shippingUnlocked) {
      rewardMessage.innerHTML = 'Spend another ' + formatMoney(shippingThreshold - total) + ' to get <strong>FREE SHIPPING!</strong>';
    } else if (total < freeGiftThreshold) {
      rewardMessage.innerHTML = 'You have <strong>FREE SHIPPING!</strong> Spend another ' + formatMoney(freeGiftThreshold - total) + ' to unlock your free gift.';
    } else {
      rewardMessage.innerHTML = 'You have unlocked <strong>FREE SHIPPING</strong> and your <strong>FREE GIFT!</strong>';
    }
  }

  function renderFooter(cart) {
    var countText = cart.item_count === 1 ? 'Subtotal (1 item)' : 'Subtotal (' + cart.item_count + ' items)';
    if (subtotalLabel) subtotalLabel.textContent = countText;
    if (subtotal) subtotal.innerHTML = formatMoney(cart.total_price || 0);

    if (checkout) {
      checkout.href = checkoutUrl;
      checkout.innerHTML = cart.item_count > 0 ? 'Secure Checkout - ' + formatMoney(cart.total_price || 0) : 'Secure Checkout';
      // Keep a nonempty cart clickable so a failed gift check can be retried.
      // prepareCheckout() is the actual safety gate, not aria-disabled or CSS.
      checkout.setAttribute('aria-disabled', cart.item_count > 0 ? 'false' : 'true');
    }

    if (giftWrapTrigger) {
      var hasGiftWrap = Boolean(findGiftWrapItem(cart));
      giftWrapTrigger.disabled = cart.item_count === 0 && !hasGiftWrap;
      giftWrapTrigger.setAttribute('aria-pressed', hasGiftWrap ? 'true' : 'false');
      giftWrapTrigger.classList.toggle('is-selected', hasGiftWrap);
    }

    if (giftWrapCheckbox) {
      giftWrapCheckbox.classList.toggle('is-selected', Boolean(findGiftWrapItem(cart)));
    }
  }

  function renderItems(cart) {
    if (!itemsMount) return;

    if (!cart.items || cart.items.length === 0) {
      itemsMount.innerHTML = '<div class="ho-cart-drawer__empty"><h3>Your cart is empty</h3><p>Add something lovely and it will appear here.</p><a href="/collections/all">Continue shopping</a></div>';
      return;
    }

    itemsMount.innerHTML = cart.items.map(function (item) {
      return renderItem(item);
    }).join('');
  }

  function renderItem(item) {
    var isGiftWrap = isGiftWrapItem(item);
    var isFreeGift = isFreeGiftItem(item);
    var isSmartSubscriptionSample = isSmartSubscriptionSampleItem(item);
    var isMagnesiumSmartGift = isMagnesiumSmartGiftItem(item);
    var hasSubscription = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    var handle = item.handle || handleFromUrl(item.url);
    var image = item.image ? '<img src="' + escapeAttr(resizeImage(item.image, '240x240')) + '" alt="' + escapeAttr(item.product_title || item.title || '') + '" loading="lazy" width="108" height="108">' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="ho-cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
    var plan = hasSubscription ? '<div class="ho-cart-drawer__item-plan">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</div>' : '';
    var properties = renderProperties(item.properties);
    var price = item.final_line_price != null ? item.final_line_price : item.line_price;
    var isManagedGift = isFreeGift || isSmartSubscriptionSample || isMagnesiumSmartGift;
    var removeButton = isManagedGift ? '' : '<button type="button" class="ho-cart-drawer__remove" data-cart-drawer-remove data-key="' + escapeAttr(item.key) + '" aria-label="Remove ' + escapeAttr(item.product_title || item.title || 'item') + '">&times;</button>';

    return '' +
      '<article class="ho-cart-drawer__item" data-key="' + escapeAttr(item.key) + '">' +
        '<div class="ho-cart-drawer__item-main">' +
          (isMagnesiumSmartGift ? '<div class="ho-cart-drawer__item-image">' + image + '</div>' : '<a class="ho-cart-drawer__item-image" href="' + escapeAttr(item.url || '#') + '">' + image + '</a>') +
          '<div class="ho-cart-drawer__item-details">' +
            (isMagnesiumSmartGift ? '<span class="ho-cart-drawer__item-title">' + escapeHtml(item.product_title || item.title || '') + '</span>' : '<a class="ho-cart-drawer__item-title" href="' + escapeAttr(item.url || '#') + '">' + escapeHtml(item.product_title || item.title || '') + '</a>') +
            variant + plan + properties +
            (isMagnesiumSmartGift ? '<div class="ho-cart-drawer__item-plan">First Smart delivery only · Quantity ' + Number(item.quantity || 0) + '</div>' : '') +
            (isGiftWrap || isManagedGift ? '' : renderQuantity(item)) +
          '</div>' +
          removeButton +
          '<div class="ho-cart-drawer__item-price">' + formatMoney(price || 0) + '</div>' +
        '</div>' +
        // Tiered quantity offers intentionally disabled.
        // Keep renderTierButtons() below so the feature can be restored easily.
        '' +
        (isGiftWrap || isManagedGift || hasSubscription ? '' : renderSubscriptionRow(item, handle)) +
      '</article>';
  }

  function renderQuantity(item) {
    var step = isMagnesiumSmartLine(item) ? 4 : 1;
    return '' +
      '<div class="ho-cart-drawer__qty">' +
        '<button type="button" data-cart-drawer-quantity-button data-key="' + escapeAttr(item.key) + '" data-quantity="' + Math.max(0, item.quantity - step) + '" aria-label="Decrease quantity">-</button>' +
        '<input type="number" min="0" step="' + step + '" inputmode="numeric" value="' + item.quantity + '" data-cart-drawer-quantity-input data-key="' + escapeAttr(item.key) + '" aria-label="Quantity">' +
        '<button type="button" data-cart-drawer-quantity-button data-key="' + escapeAttr(item.key) + '" data-quantity="' + (item.quantity + step) + '" aria-label="Increase quantity">+</button>' +
      '</div>' + (step === 4 ? '<div class="ho-cart-drawer__item-plan">Smart pack: 4 bottles per pack</div>' : '');
  }

  function renderTierButtons(item) {
    return '' +
      '<div class="ho-cart-drawer__tiers" aria-label="Quantity offers">' +
        '<button type="button" class="ho-cart-drawer__tier" data-cart-drawer-tier data-key="' + escapeAttr(item.key) + '" data-quantity="2">Buy 2 save 10%</button>' +
        '<button type="button" class="ho-cart-drawer__tier" data-cart-drawer-tier data-key="' + escapeAttr(item.key) + '" data-quantity="3">Buy 3 save 15%</button>' +
        '<button type="button" class="ho-cart-drawer__tier" data-cart-drawer-tier data-key="' + escapeAttr(item.key) + '" data-quantity="4">Buy 4 save 20%</button>' +
      '</div>';
  }

  function renderSubscriptionRow(item, handle) {
    if (!handle) return '';
    return '' +
      '<label class="ho-cart-drawer__subscription" data-cart-drawer-subscription data-product-handle="' + escapeAttr(handle) + '" data-key="' + escapeAttr(item.key) + '" data-quantity="' + item.quantity + '" hidden>' +
        '<input type="checkbox" aria-label="Upgrade to subscription and save">' +
        '<span class="ho-cart-drawer__fake-checkbox" aria-hidden="true"></span>' +
        '<span>Upgrade to subscription &amp; save 15% <a href="/pages/terms-conditions">Terms &amp; Conditions (T&amp;C)</a></span>' +
      '</label>';
  }

  function hydrateSubscriptionRows(cart) {
    if (!cart.items || !cart.items.length) return;

    root.querySelectorAll('[data-cart-drawer-subscription]').forEach(function (row) {
      var handle = row.dataset.productHandle;
      if (!handle) return;

      getProduct(handle)
        .then(function (product) {
          if (firstSellingPlan(product)) row.hidden = false;
        })
        .catch(function () {
          row.hidden = true;
        });
    });
  }

  function renderProperties(properties) {
    if (!properties) return '';

    var rows = [];
    Object.keys(properties).forEach(function (key) {
      if (!properties[key] || key.charAt(0) === '_') return;
      rows.push(escapeHtml(key) + ': ' + escapeHtml(String(properties[key])));
    });

    return rows.length ? '<div class="ho-cart-drawer__item-properties">' + rows.join('<br>') + '</div>' : '';
  }

  function findGiftWrapItem(cart) {
    return findCartItem(cart, isGiftWrapItem);
  }

  function findFreeGiftItem(cart) {
    return findCartItem(cart, isFreeGiftItem);
  }

  function findSmartSubscriptionSampleItem(cart) {
    return findCartItem(cart, isSmartSubscriptionSampleItem);
  }

  function findCartItem(cart, predicate) {
    var items = cart && cart.items ? cart.items : [];
    for (var i = 0; i < items.length; i += 1) {
      if (predicate(items[i])) return items[i];
    }
    return null;
  }

  function isGiftWrapItem(item) {
    if (!item) return false;
    if (giftWrapVariantId && Number(item.variant_id) === giftWrapVariantId) return true;
    return String(item.product_title || item.title || '').toLowerCase() === 'gift wrap';
  }

  function isFreeGiftItem(item) {
    if (!item) return false;
    if (freeGiftVariantId && Number(item.variant_id) === freeGiftVariantId) return true;
    if (freeGiftProductId && Number(item.product_id) === freeGiftProductId) return true;
    return String(item.product_title || item.title || '').toLowerCase() === 'surprise & delight free soap bar';
  }

  function isSmartSubscriptionSampleItem(item) {
    if (!item) return false;

    var properties = item.properties || {};
    if (properties._smart_subscription_sample === 'true') return true;
    if (smartSubscriptionSampleVariantId && Number(item.variant_id) === smartSubscriptionSampleVariantId) return true;
    if (smartSubscriptionSampleProductId && Number(item.product_id) === smartSubscriptionSampleProductId) return true;
    if (smartSubscriptionSampleSku && String(item.sku || '').toLowerCase() === String(smartSubscriptionSampleSku).toLowerCase()) return true;

    return false;
  }

  function isCurrentFreeGiftLine(item) {
    var properties = item && item.properties ? item.properties : {};
    var hasRebuyAttribution = properties._source === 'Rebuy' && properties._attribution === 'Rebuy Tiered Progress Bar';
    var hasCorrectTier = !freeGiftTierId || properties._tier === freeGiftTierId;
    var isDiscounted = Number(item.final_line_price != null ? item.final_line_price : item.line_price) === 0;

    return hasRebuyAttribution && hasCorrectTier && isDiscounted;
  }

  function isCurrentSmartSubscriptionSampleLine(item) {
    var properties = item && item.properties ? item.properties : {};

    return properties._source === 'Harrogate Organics'
      && properties._attribution === 'Smart Subscription Sample'
      && properties._smart_subscription_sample === 'true';
  }

  function isMagnesiumSmartGiftItem(item) {
    // Only the dedicated free SKU, never the normal paid pillow-spray product.
    return magnesiumSmartGiftVariantId > 0 && item
      && Number(item.variant_id || item.id) === magnesiumSmartGiftVariantId
      && String(item.sku || '').trim().toLowerCase() === magnesiumSmartGiftSku;
  }

  function isCurrentMagnesiumSmartGiftLine(item) {
    var properties = item && item.properties ? item.properties : {};
    var price = item && (item.final_line_price != null ? item.final_line_price : item.line_price);
    return isMagnesiumSmartGiftItem(item) && !item.selling_plan_allocation && !item.selling_plan
      && price != null && Number(price) === 0
      && properties._source === 'Harrogate Organics'
      && properties._attribution === 'Magnesium Smart Pillow Gift'
      && properties._magnesium_smart_gift === 'true';
  }

  function magnesiumSmartGiftQuantity(cart) {
    if (!(magnesiumSmartGiftVariantId > 0)) return 0;
    return (cart.items || []).filter(function (item) {
      return isMagnesiumSmartLine(item) && Number.isInteger(item.quantity) && item.quantity >= 4 && item.quantity % 4 === 0;
    }).length;
  }

  function isMagnesiumSmartGiftCartValid(cart) {
    if (!(magnesiumSmartGiftVariantId > 0)) return true;
    if (!cart || !Array.isArray(cart.items)) return false;
    var quantity = magnesiumSmartGiftQuantity(cart);
    var items = (cart.items || []).filter(isMagnesiumSmartGiftItem);
    return quantity === 0 ? items.length === 0 : items.length === 1 && isCurrentMagnesiumSmartGiftLine(items[0]) && items[0].quantity === quantity;
  }

  function hasQualifyingSampleSubscription(cart) {
    return (cart.items || []).some(function (item) {
      return isSmartSubscriptionLine(item) && (!(magnesiumSmartGiftVariantId > 0) || !isMagnesiumSmartLine(item));
    });
  }

  function hasQualifyingSmartSubscription(cart) {
    var items = cart && cart.items ? cart.items : [];
    return items.some(isSmartSubscriptionLine);
  }

  function hasSubscriptionFreeShipping(cart) {
    var shippingItems = (cart.items || []).filter(function (item) {
      return Number(item.quantity) > 0 && item.requires_shipping !== false
        && !isMagnesiumSmartGiftItem(item);
    });
    return shippingItems.length > 0 && shippingItems.every(function (item) {
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      var properties = item.properties || {};
      return isSmartSubscriptionLine(item) || Boolean(plan && item.handle === 'hair-skin-nails'
        && properties._hsn_ritual === 'trial');
    });
  }

  function isMagnesiumSmartLine(item) {
    if (!item || !item.selling_plan_allocation || !item.selling_plan_allocation.selling_plan) return false;
    return String(item.selling_plan_allocation.selling_plan.id) === '711250772354'
      && ['44115539591387', '37267818250408', '45540237377755'].indexOf(String(item.variant_id || item.id)) !== -1;
  }

  function isSmartSubscriptionLine(item) {
    if (!item || isGiftWrapItem(item) || isFreeGiftItem(item) || isSmartSubscriptionSampleItem(item)) return false;
    if (!item.selling_plan_allocation || !item.selling_plan_allocation.selling_plan) return false;

    var properties = item.properties || {};
    // The new HSN trial receives its sample with the first Smart renewal, not today.
    if (properties._hsn_ritual === 'trial') return false;
    if (properties._smart_subscription === 'true') return true;

    var planName = String(item.selling_plan_allocation.selling_plan.name || '').toLowerCase();
    return planName.indexOf('smart') > -1;
  }

  function rewardSubtotal(cart) {
    var items = cart && cart.items ? cart.items : [];
    return items.reduce(function (sum, item) {
      if (isFreeGiftItem(item) || isSmartSubscriptionSampleItem(item) || isMagnesiumSmartGiftItem(item)) return sum;
      var linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
      return sum + Number(linePrice || 0);
    }, 0);
  }

  function hasQualifyingItems(cart) {
    var items = cart && cart.items ? cart.items : [];
    return items.some(function (item) {
      return !isFreeGiftItem(item) && !isGiftWrapItem(item) && !isSmartSubscriptionSampleItem(item) && !isMagnesiumSmartGiftItem(item) && item.quantity > 0;
    });
  }

  function readVitaminDOfferConfig(element) {
    if (!element) return null;
    try {
      var config = JSON.parse(element.textContent);
      if (!(Number(config.variantId) > 0) || !(Number(config.productId) > 0)
        || !(Number(config.offerPrice) > 0) || !(Number(config.startsAt) < Number(config.endsAt))
        || !Array.isArray(config.eligibleProductIds) || !config.eligibleProductIds.length) return null;
      return config;
    } catch (error) {
      return null;
    }
  }

  function isVitaminDOfferEligible(cart) {
    if (!vitaminDOfferConfig || !cart || !Array.isArray(cart.items)) return false;
    var now = Date.now();
    if (now < vitaminDOfferConfig.startsAt || now >= vitaminDOfferConfig.endsAt) return false;
    // The October discount cannot combine with other Shopify discounts.
    // Selling-plan prices are not excluded: qualifying subscriptions are allowed.
    if ((cart.cart_level_discount_applications || []).length
      || (cart.discount_codes || []).some(function (code) { return code.applicable; })) return false;
    if (cart.items.some(function (item) {
      return Number(item.product_id) === Number(vitaminDOfferConfig.productId)
        || Number(item.variant_id || item.id) === Number(vitaminDOfferConfig.variantId)
        || item.handle === 'vitamin-d3-vitamin-k2-mk7'
        || (item.line_level_discount_allocations || []).length > 0;
    })) return false;
    return cart.items.some(function (item) {
      return Number(item.quantity) > 0
        && vitaminDOfferConfig.eligibleProductIds.indexOf(Number(item.product_id)) !== -1;
    });
  }

  function isVitaminDQualifyingPromptEligible(cart) {
    if (!vitaminDOfferConfig || !cart || !Array.isArray(cart.items)) return false;
    var now = Date.now();
    if (now < vitaminDOfferConfig.startsAt || now >= vitaminDOfferConfig.endsAt) return false;
    // Keep the reverse prompt aligned with the same non-combinable October offer.
    if ((cart.cart_level_discount_applications || []).length
      || (cart.discount_codes || []).some(function (code) { return code.applicable; })
      || cart.items.some(function (item) {
        return Number(item.quantity) > 0 && (item.line_level_discount_allocations || []).length > 0;
      })) return false;
    var hasOneTimeVitaminD = cart.items.some(function (item) {
      return Number(item.quantity) > 0 && !item.selling_plan_allocation
        && (Number(item.product_id) === Number(vitaminDOfferConfig.productId)
          || Number(item.variant_id || item.id) === Number(vitaminDOfferConfig.variantId)
          || item.handle === 'vitamin-d3-vitamin-k2-mk7');
    });
    var hasQualifyingProduct = cart.items.some(function (item) {
      return Number(item.quantity) > 0
        && vitaminDOfferConfig.eligibleProductIds.indexOf(Number(item.product_id)) !== -1;
    });
    return hasOneTimeVitaminD && !hasQualifyingProduct;
  }

  function renderVitaminDOffer(cart) {
    if (vitaminDOffer) vitaminDOffer.hidden = !isVitaminDOfferEligible(cart);
    if (vitaminDQualifyingPrompt) vitaminDQualifyingPrompt.hidden = !isVitaminDQualifyingPromptEligible(cart);
    if (vitaminDOfferButton) vitaminDOfferButton.disabled = vitaminDOfferAdding;
  }

  function addVitaminDOffer(button) {
    if (vitaminDOfferAdding || state.cartMutationCount > 0 || state.isCartChanging) return;
    if (!isVitaminDOfferEligible(state.cart)) {
      renderVitaminDOffer(state.cart);
      return;
    }
    vitaminDOfferAdding = true;
    state.cartMutationCount += 1;
    setBusy(button, true, 'Adding...');
    setRootLoading(true);
    // Recheck the current server basket before adding; never add a selling_plan.
    return fetchCartJson()
      .then(function (cart) {
        if (!isVitaminDOfferEligible(cart)) return normalizeCart(cart);
        return addVariant(vitaminDOfferConfig.variantId, 1, null);
      })
      .then(function () {
        var added = state.cart && state.cart.items && state.cart.items.find(function (item) {
          return Number(item.variant_id || item.id) === Number(vitaminDOfferConfig.variantId)
            && !item.selling_plan_allocation;
        });
        if (added && Number(added.final_price) > Number(vitaminDOfferConfig.offerPrice)) {
          showNotice('Vitamin D is in your basket, but the 50% offer has not applied. Please check your basket before checkout; this offer cannot combine with other discounts.');
        }
      })
      .catch(function (error) {
        showNotice(error.message || 'Vitamin D could not be added. Please try again.');
      })
      .finally(function () {
        vitaminDOfferAdding = false;
        state.cartMutationCount -= 1;
        setBusy(button, false);
        setRootLoading(false);
        renderVitaminDOffer(state.cart);
      });
  }
  function renderRecommendations(cart) {
    if (!recommendations || !recommendationTrack) return;

    if (!cart.items || !cart.items.length) {
      recommendations.hidden = true;
      recommendationTrack.innerHTML = '';
      state.recommendationSeed = null;
      return;
    }

    var seedItem = cart.items[cart.items.length - 1];
    var seed = seedItem && seedItem.product_id;
    if (!seed || seed === state.recommendationSeed) return;

    state.recommendationSeed = seed;
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(seed) + '&limit=8&intent=related', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(parseResponse)
      .then(function (data) {
        var cartProductIds = cart.items.map(function (item) { return item.product_id; });
        var products = (data.products || []).filter(function (product) {
          return cartProductIds.indexOf(product.id) === -1;
        }).slice(0, 6);

        if (!products.length) {
          recommendations.hidden = true;
          recommendationTrack.innerHTML = '';
          return;
        }

        recommendationTrack.innerHTML = products.map(renderRecommendation).join('');
        recommendations.hidden = false;
      })
      .catch(function () {
        recommendations.hidden = true;
      });
  }

  function renderRecommendation(product) {
    var variant = firstAvailableVariant(product);
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var comparePrice = variant && variant.compare_at_price && variant.compare_at_price > variant.price ? ' <s>' + formatMoney(variant.compare_at_price) + '</s>' : '';

    return '' +
      '<article class="ho-cart-drawer__recommendation-card">' +
        (image ? '<img src="' + escapeAttr(resizeImage(image, '360x360')) + '" alt="' + escapeAttr(product.title) + '" loading="lazy" width="160" height="160">' : '') +
        '<a class="ho-cart-drawer__recommendation-title" href="' + escapeAttr(product.url || '#') + '">' + escapeHtml(product.title) + '</a>' +
        '<p class="ho-cart-drawer__recommendation-price">' + (variant ? formatMoney(variant.price) : '') + comparePrice + '</p>' +
        (variant ? '<button type="button" class="ho-cart-drawer__recommendation-add" data-cart-drawer-recommendation-add data-variant-id="' + variant.id + '">Add To Cart +</button>' : '') +
      '</article>';
  }

  function firstAvailableVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i].available !== false) return variants[i];
    }
    return variants[0] || null;
  }

  function getProduct(handle) {
    if (state.productCache[handle]) return state.productCache[handle];
    state.productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(parseResponse);
    return state.productCache[handle];
  }

  function firstSellingPlan(product) {
    var groups = product && product.selling_plan_groups ? product.selling_plan_groups : [];
    for (var i = 0; i < groups.length; i += 1) {
      var plans = groups[i].selling_plans || [];
      if (plans.length) return plans[0];
    }
    return null;
  }

  function openDrawer() {
    state.lastFocus = document.activeElement;
    state.isOpen = true;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ho-cart-drawer-open');

    window.setTimeout(function () {
      if (panel) panel.focus();
    }, 20);
  }

  function closeDrawer() {
    state.isOpen = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ho-cart-drawer-open');

    if (state.lastFocus && typeof state.lastFocus.focus === 'function') {
      state.lastFocus.focus();
    }
  }

  function scrollRecommendations(direction) {
    if (!recommendationTrack) return;
    var distance = Math.max(recommendationTrack.clientWidth * 0.85, 220);
    recommendationTrack.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }

  function updateCounters(cart) {
    document.querySelectorAll('.js-go-cart-counter').forEach(function (counter) {
      counter.textContent = cart.item_count;
    });
  }

  function parseResponse(response) {
    return response.text().then(function (body) {
      var data = parseJsonBody(response, body);
      if (!response.ok || data.status === 422) {
        throw new Error(data.description || data.message || 'Request failed.');
      }
      return data;
    });
  }

  function parseJsonBody(response, body) {
    var contentType = response.headers && response.headers.get ? response.headers.get('content-type') || '' : '';
    var text = body || '';
    var trimmed = text.trim();
    var looksJson = trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[';

    if (!trimmed) return {};

    if (contentType.indexOf('application/json') === -1 && !looksJson) {
      throw unexpectedResponseError(response);
    }

    try {
      return JSON.parse(trimmed);
    } catch (error) {
      throw unexpectedResponseError(response);
    }
  }

  function unexpectedResponseError(response) {
    var status = response && response.status ? ' (' + response.status + ')' : '';
    return new Error('The cart returned an unexpected response' + status + '. Please refresh and try again.');
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Shopify && typeof window.theme.Shopify.formatMoney === 'function') {
      return window.theme.Shopify.formatMoney(cents, moneyFormat);
    }

    var value = (Number(cents || 0) / 100).toFixed(2);
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = moneyFormat.match(placeholder);
    if (!match) return '\u00a3' + value;
    return moneyFormat.replace(placeholder, value);
  }

  function resizeImage(src, size) {
    if (!src) return '';
    var parts = String(src).split('?');
    var path = parts[0];
    var query = parts[1] ? '?' + parts[1] : '';
    return path.replace(/(\.(?:jpg|jpeg|png|webp|gif))$/i, '_' + size + '$1') + query;
  }

  function handleFromUrl(url) {
    if (!url) return '';
    var match = String(url).match(/\/products\/([^/?#]+)/);
    return match && match[1] ? decodeURIComponent(match[1]) : '';
  }

  function setBusy(button, isBusy, busyText) {
    if (!button) return;
    if (isBusy) {
      button.dataset.originalText = button.textContent;
      button.textContent = busyText || 'Loading...';
      button.disabled = true;
      button.dataset.loading = 'true';
    } else {
      button.textContent = button.dataset.originalText || button.textContent;
      button.disabled = false;
      button.dataset.loading = 'false';
    }
  }

  function setRootLoading(isLoading) {
    root.classList.toggle('is-loading', isLoading);
  }

  function showNotice(message) {
    if (!notice) return;
    notice.textContent = message;
    notice.hidden = false;
    if (body) body.scrollTop = 0;
  }

  function clearNotice() {
    if (!notice) return;
    notice.hidden = true;
    notice.textContent = '';
  }

  function showGiftWrapNotice(message) {
    if (!giftModalNotice) return;
    giftModalNotice.textContent = message;
    giftModalNotice.hidden = false;
  }

  function clearGiftWrapNotice() {
    if (!giftModalNotice) return;
    giftModalNotice.hidden = true;
    giftModalNotice.textContent = '';
  }

  function toggleClass(element, className, enabled) {
    if (!element) return;
    element.classList.toggle(className, Boolean(enabled));
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

